import './GroupsFilter.css';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Select } from 'antd';

import { utils } from '../../../../../helpers';
import { isFunction } from 'util';

const Option = Select.Option;

@inject('translationsStore')
@observer
export default class GroupsFilter extends Component {
  constructor(props) {
    super(props);
    this.groupId = `GroupsFilter_${utils.getRandomIntInclusive(10000, 99999)}_${new Date().getTime()}`;
  }

  onChange = value => {
    if (isFunction(this.props.onChange)) {
      this.props.onChange(value);
    }
  };

  render() {
    const { translationsStore, groups } = this.props;
    return (
      <div className="GroupsFilter" style={{ textTransform: 'uppercase', fontWeight: '700' }} id={this.groupId}>
        <Select size="default" defaultValue={-1} getPopupContainer={() => document.getElementById(`${this.groupId}`)} onChange={this.onChange}>
          <Option value={-1}>{translationsStore.translate('groupsfilter.placeholder')}</Option>
          {groups.map((group, index) => {
            return (
              <Option key={index} value={group.id}>
                {group.name}
              </Option>
            );
          })}
        </Select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientList/GroupsFilter/GroupsFilter.js